import styled from 'styled-components'

export default styled.div`
  display: flex;
  margin-right: 0.5rem;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;

  > header {
    margin-right: 1rem;
  }
`
